import { render, staticRenderFns } from "./ContainersWidget.vue?vue&type=template&id=2ad2cf60&scoped=true"
import script from "./ContainersWidget.vue?vue&type=script&lang=js"
export * from "./ContainersWidget.vue?vue&type=script&lang=js"
import style0 from "./ContainersWidget.vue?vue&type=style&index=0&id=2ad2cf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2cf60",
  null
  
)

export default component.exports